<template>
  <div class="home">
    <div class="mian mainHome">
      <div class="mianWrap">
        <!-- 轮播图 -->
        <home-banner ref="homeBanner" :height="645"></home-banner>
        <!-- 新闻中心 -->
        <div class="News">
          <div class="main_panel">
            <div class="ComTit">
              <!-- <div class="t1" date-aos="fade-right" data-aos-easing = "ease-in-out" data-aos-delay = "50" >NEWS CENTER</div>
              <div class="t2" date-aos="fade-left" data-aos-easing = "ease-in-out">新闻中心</div> -->
              <div class="t1 wow animate__animated animate__fadeInRight" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s" >NEWS CENTER</div>
              <div class="t2 wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s"  >新闻中心</div>             
            </div>
            <div class="homeNewsHd" style="text-align: center; width: 1200px;">
              <span class="homeNewsHdInner" :class="{active : activeNewsHd == index}" v-for="(item, index) in newsHdList" :key="index" @mouseenter="mouseenterNewsHd(index)">
                <a :href="item.url" target="_balnk">{{ item.title }}</a>
              </span>
            </div>
            <div class="homeNewsCon">
              <ul class="news_list" v-if="activeNewsHd == 0">
                <li v-for="(item,index) in news01" :key="index" >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>  
                  </div>
                </li>
              </ul>

              <ul class="news_list" v-if="activeNewsHd == 1">
                <li v-for="(item,index) in news02" :key="index" >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>
                    <!-- <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`"> -->
                    <a v-else target="_blank" :href="`/detail/00280002/${item.entTArticleUuid}`">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>  
                  </div>
                </li>
              </ul>

              <ul class="news_list" v-if="activeNewsHd == 2">
                <li v-for="(item,index) in news03" :key="index" >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>  
                  </div>
                </li>
              </ul>

              <ul class="news_list" v-if="activeNewsHd == 3">
                <li v-for="(item,index) in news04" :key="index" >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="newsImg">
                        <img :src="item.thumb1" alt="">
                      </div>
                      <div class="nr">
                        <p class="single-line">{{item.title}} </p>
                        <span style="color: #888888;">{{item.artDesc | ellipsis}}</span>
                        <br>
                        <span>{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                    </a>  
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 业务中心 -->
        <div class="business">
          <div class="main_panel">
            <div class="ComTit">
              <div class="t1 wow animate__animated animate__fadeInRight" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s" >BUSINESS CENTER</div>
              <div class="t2 wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s"  >业务中心</div>     
            </div>
            <div class="Product">
              <ul>
                <li style="margin-left:0px;" class="wow animate__animated animate__fadeInLeft" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s" >
                  <a href="/list/00290001">
                    <div class="p1">
                      <span ><i class="iconfont">&#xe629;</i></span>
                    </div>
                    <h3>信息技术系统建设和服务</h3>
                    <div class="p2">
                      <a href="/list/00290001">信息技术系统建设和服务</a>
                    </div>
                    <a href="/list/00290001" class="more">查看更多</a>
                  </a>
                </li>
                <li class="wow animate__animated animate__fadeInDown" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s">
                  <a href="/list/00290002">
                    <div class="p1">
                      <span><i class="iconfont">&#xe606;</i></span>
                    </div>
                    <h3>软件开发</h3>
                    <div class="p2">
                      <a href="/list/00290002">软件开发</a>
                    </div>
                    <a href="/list/00290002" class="more">查看更多</a>
                  </a>
                </li>
                <li class="wow animate__animated animate__fadeInLeft" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s">
                  <a @click="zhgdClick" style="cursor: pointer;">
                    <div class="p1">
                      <span><i class="iconfont" style="font-weight: 600;">&#xe737;</i></span>
                    </div>
                    <h3>智慧工地服务</h3>
                    <div class="p2">
                      <a>智慧工地服务</a>
                    </div>
                    <a class="more">查看更多</a>
                  </a>
                </li>
                <li class="wow animate__animated animate__fadeInDown" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s">
                  <a href="/list/00290003">
                    <div class="p1">
                      <span><i class="iconfont">&#xe7cc;</i></span>
                    </div>
                    <h3>涉密信息系统集成</h3>
                    <div class="p2">
                      <a href="/list/00290003">涉密信息系统集成</a>
                    </div>
                    <a href="/list/00290003" class="more">查看更多</a>
                  </a>
                </li>
                <li style="margin-top: 15px; margin-left: 0px" class="wow animate__animated animate__fadeInUp" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s">
                  <a href="/list/00290004">
                    <div class="p1">
                      <span><i class="iconfont">&#xe61b;</i></span>
                    </div>
                    <h3>信息系统运维</h3>
                    <div class="p2">
                      <a href="/list/00290004">信息系统运维</a>
                    </div>
                    <a href="/list/00290004" class="more">查看更多</a>
                  </a>
                </li>
                <li style="margin-top: 15px;" class="wow animate__animated animate__fadeInDown" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s">
                  <a href="/list/00290005">
                    <div class="p1">
                      <span><i class="iconfont">&#xe9ee;</i></span>
                    </div>
                    <h3>网络安全</h3>
                    <div class="p2">
                      <a href="/list/00290005">网络安全</a>
                    </div>
                    <a href="/list/00290005" class="more">查看更多</a>
                  </a>
                </li>
                <li style="margin-top: 15px;" class="wow animate__animated animate__fadeInUp" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s">
                  <a href="/list/00290006">
                    <div class="p1">
                      <span><i class="iconfont">&#xe616;</i></span>
                    </div>
                    <h3>照明与亮化工程</h3>
                    <div class="p2">
                      <a href="/list/00290006">照明与亮化工程</a>
                    </div>
                    <a href="/list/00290006" class="more">查看更多</a>
                  </a>
                </li>

                <li style="margin-top: 15px;" class="wow animate__animated animate__fadeInDown" data-wow-delay="0.6s"  data-wow-iteration= "1"  data-wow-duration="0.6s">
                  <a href="/listPic/00290007">
                    <div class="p1">
                      <span><i class="iconfont">&#xe839;</i></span>
                    </div>
                    <h3>建筑智能化</h3>
                    <div class="p2">
                      <a href="/listPic/00290007">建筑智能化</a>
                    </div>
                    <a href="/listPic/00290007" class="more">查看更多</a>
                  </a>
                </li>
              </ul>
            </div>

          </div>

        </div>
        <!-- 项目案例 -->
        <div class="About">
          <div class="main_panel">
            <div class="ComTit">
              <div class="t1 wow animate__animated animate__fadeInRight" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s" >PROJECT CASE</div>
              <div class="t2 wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s"  >项目案例</div>     
            </div>

            <div class="AboutMain" id="AboutProj">     
              <div class="AboutSwiper-container swiper-container" id="AboutPhoto">
                <div class="AboutSwiper-wrapper swiper-wrapper" >
                  <div class="AboutSwiper-slide swiper-slide"  v-for="(item,index) in AboutList" :key="index" >
                    <a :href="item.url" v-if="item.url && item.url !== ''" class="AboutItem" target="_blank" >
                      <div class="img">
                        <img class="swiper_img" :src="item.thumb1" style="width: 100%; ">
                      </div>
                      <div class="Tit" >{{item.title }} </div>
                    </a>
                    <a
                      class="AboutItem"
                      v-else
                      target="_blank"
                      :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="img">
                        <img class="swiper_img" :src="item.thumb1" style="width: 100%; ">
                      </div>
                      <div class="Tit" >{{item.title }} </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-button-prev swiper-button-prev-About"></div>
                <div class="swiper-button-next swiper-button-next-About"></div>
              </div>
            </div>
            <a href="/list/01340002" target="_blank" class="Aboutmore">查看更多</a>

          </div>

        </div>
        <!-- 合作伙伴 -->
        <div class="Partner">
          <div class="main_panel">
            <div class="ComTit" style="margin-top: 50px;">
              <div class="t1 wow animate__animated animate__fadeInRight" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s" >PAETNER</div>
              <div class="t2 wow animate__animated animate__fadeInLeft" data-wow-delay="0.5s"  data-wow-iteration= "1"  data-wow-duration="0.5s"  >合作伙伴</div>  
            </div>

            <div class="PartnerMain" id="PartnerProj">     
              <div class="PartSwiper-container swiper-container" id="PartPhoto">
                <div class="PartSwiper-wrapper swiper-wrapper" >
                  <div class="PartSwiper-slide swiper-slide"  v-for="(item,index) in PartList" :key="index" >
                    <a :href="item.url" v-if="item.url && item.url !== ''" class="PartItem" target="_blank" >
                      <div class="img">
                        <img class="Part_img" :src="item.thumb1" style="width: 100%; ">
                      </div>
                      <div class="PatBack">
                        <div class="PartTit" >{{item.title }} </div>
                      </div>
                    </a>
                    <a
                      class="PartItem"
                      v-else
                      target="_blank"
                      :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="img">
                        <img class="Part_img" :src="item.thumb1" style="width: 100%; ">
                      </div>
                      <div class="PatBack">
                        <div class="PartTit" >{{item.title }} </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="swiper-button-prev swiper-button-prev-Part"></div>
                <div class="swiper-button-next swiper-button-next-Part"></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 飘窗 -->
    <window-box ref="windowBox"></window-box>
    <!-- <window-box2 ref="windowBox2"></window-box2> -->
    <!-- 智慧工地宣传视频    -->
    <el-dialog
      title="《甘肃省“BIM+智慧工地”项目管理平台》宣传片 "
      top = "4%"
      destroy-on-close
      @close='closeDialog'
      :visible.sync="dialogVisible"
      width="60%">
      <div class="dialogContainer">
        <div class="homeVideo">
          <video controls loop autoplay muted style="height: 100%; width: 100%; object-fit: fill; ">
            <source src="../assets/img/《甘肃省“BIM+智慧工地”项目管理平台》宣传片.mp4" type="video/mp4">
          </video>  
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div class="formFooter" style="text-align: center;">
          <el-button @click="zhgdClose" size="small">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {picArticles} from '@/api/common'
// import 'aos/dist/aos.css'
// import AOS from 'aos/dist/aos.js'
// import wow from 'wowjs' 
import Swiper from 'swiper'
import homeBanner from "@/components/bannerimg.vue"
import windowBox from '@/components/windowBox/index.vue'
// import windowBox2 from '@/components/windowBox/index2.vue'
export default {
  components: {
    homeBanner,
    windowBox,
    // windowBox2,
  },
  name: 'home',
  data(){
    return {
      dialogVisible: false,
      list: true,
      activeNewsHd: 0,
      newsHdList:[
        {
          title:'公司新闻',
          url: '/list/00280001',
        },
        {
          title:'建投要闻',
          url: '/list/00280002',
        },
        {
          title:'党建工作',
          url: '/list/00280003',
        },
        {
          title:'“三抓三促”行动专栏',
          url: '/list/1ca7be7f-c3d9-46fd-9727-5dca39027380',
        },
      ],
      news01:[],
      news02:[],
      news03:[],
      news04:[],
      AboutList:[],
      PartList:[],
    }
  },
  mounted(){
    // this.$AOS.init({
    //   offset: 200,   
    //   duration: 600,   
    //   easing: 'ease-in-sine',   
    //   delay: 100
    // });
    new this.$wow.WOW().init({
      boxClass: 'wow',
      animateClass: 'animate__animated',
      offset: 0,
      mobile: true,
      live: true
    })
    this.homeNews()
    this.bannerAbout()
    this.bannerPart()

  },
  filters: {
    //超过100位显示 ...
    ellipsis: function(value) {
      if (!value) return ''
      if (value.length > 40) {
        return value.slice(0, 40) 
      }
      return value
    }
  },
  methods: {
    // 智慧工地宣传视频
    zhgdClick(){
      this.dialogVisible = true
    },
    zhgdClose() {
      this.dialogVisible = false
    },
    //新闻中心
    homeNews() {
      var _this = this
      //公司新闻
      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00280001',
        pageNum: 1,
        pageSize: 4
      }
      picArticles(data01).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.news01 = data.rows
        }
      })

      //建投要闻
      let data02 = {
        entTApplicationUuid: _this.webIdGroup,
        // channelUuid: '00280002',
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 4
      }
      picArticles(data02).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.news02 = data.rows
        }
      })

      //党建工作
      let data03 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00280003',
        pageNum: 1,
        pageSize: 4
      }
      picArticles(data03).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.news03 = data.rows
        }
      })

      //“三抓三促”行动专栏
      let data04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '1ca7be7f-c3d9-46fd-9727-5dca39027380',
        pageNum: 1,
        pageSize: 4
      }
      picArticles(data04).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.news04 = data.rows
        }
      })
    },
    //项目案例
    bannerAbout() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01340002',
        pageNum: 1,
        pageSize: 15
      }
      picArticles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.AboutList = data.rows
          this.$nextTick(() => {
           this.mySwiper  = new Swiper('#AboutPhoto', {
              
              loop: true,
              speed: 4000,
              autoplay: 1,
              updateOnImagesReady: true,
              slidesPerView: 3,
              spaceBetween: 25,
              prevButton:'.swiper-button-prev-About',
              nextButton:'.swiper-button-next-About',
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false
            })
            // 存放鼠标悬浮时的transform属性（行内属性）
            let nextTransForm = ''
            // 轮播图从暂停位置移动到原本应到的位置所用的时间
            let nextTime = 0

            // 鼠标悬浮暂停轮播
            this.swiper.container[0].onmouseover = function() {
              nextTransForm = document
                .getElementsByClassName('AboutSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform
              // 轮播图原本应移动到的位置
              let nextTransPosition =
                -1 *
                parseInt(
                  document
                    .getElementsByClassName('AboutSwiper-container')[0]
                    .getElementsByClassName('swiper-wrapper')[0]
                    .style.transform.split('translate3d(')[1]
                    .split('px')[0]
                )

              // 鼠标悬浮时时轮播图位置
              let nowTransPosition =
                -1 *
                parseInt(
                  window
                    .getComputedStyle(
                      document
                        .getElementsByClassName('AboutSwiper-container')[0]
                        .getElementsByClassName('swiper-wrapper')[0],
                      false
                    )['transform'].split('1, ')[2]
                    .split(',')[0]
                )
              // 存放鼠标悬浮时轮播图的真实transform属性（非行内属性）
              let nowTransForm = window.getComputedStyle(
                document.getElementsByClassName('AboutSwiper-container')[0].getElementsByClassName('swiper-wrapper')[0],
                false
              )['transform']
              // 计算轮播图从暂停位置移动到原本应到的位置所用的时间（370是我自定义的每个slide的宽度）
              nextTime = 5500 * ((nextTransPosition - nowTransPosition) / 370)
              // 改变行内transform属性
              document
                .getElementsByClassName('AboutSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nowTransForm
              // 不写也没关系
              document
                .getElementsByClassName('AboutSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = '0ms'
              this.swiper.stopAutoplay()
            }
            // 鼠标离开轮播图开始轮播
            this.swiper.container[0].onmouseout = function() {
              // console.log('leave' + nextTransForm)
              // 恢复原样
              document
                .getElementsByClassName('AboutSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nextTransForm
              document
                .getElementsByClassName('AboutSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = nextTime + 'ms'
              this.swiper.startAutoplay()
            }
          })
        }
      })
    },
    //合作伙伴
    bannerPart(){
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '00280003',
        pageNum: 1,
        pageSize: 15
      }
      picArticles(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          // _this.PartList = data.rows
          this.$nextTick(() => {
            this.mySwiper  = new Swiper('#PartPhoto', {
              loop: true,
              speed: 4000,
              autoplay: 1,
              updateOnImagesReady: true,
              slidesPerView: 3,
              spaceBetween: 25,
              prevButton:'.swiper-button-prev-About',
              nextButton:'.swiper-button-next-About',
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              autoplayDisableOnInteraction: false           
            })
            // 存放鼠标悬浮时的transform属性（行内属性）
            let nextTransForm = ''
            // 轮播图从暂停位置移动到原本应到的位置所用的时间
            let nextTime = 0

            // 鼠标悬浮暂停轮播
            this.swiper.container[0].onmouseover = function() {
              nextTransForm = document
                .getElementsByClassName('PartSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform
              // 轮播图原本应移动到的位置
              let nextTransPosition =
                -1 *
                parseInt(
                  document
                    .getElementsByClassName('PartSwiper-container')[0]
                    .getElementsByClassName('swiper-wrapper')[0]
                    .style.transform.split('translate3d(')[1]
                    .split('px')[0]
                )

              // 鼠标悬浮时时轮播图位置
              let nowTransPosition =
                -1 *
                parseInt(
                  window
                    .getComputedStyle(
                      document
                        .getElementsByClassName('PartSwiper-container')[0]
                        .getElementsByClassName('swiper-wrapper')[0],
                      false
                    )['transform'].split('1, ')[2]
                    .split(',')[0]
                )
              // 存放鼠标悬浮时轮播图的真实transform属性（非行内属性）
              let nowTransForm = window.getComputedStyle(
                document.getElementsByClassName('PartSwiper-container')[0].getElementsByClassName('swiper-wrapper')[0],
                false
              )['transform']
              // 计算轮播图从暂停位置移动到原本应到的位置所用的时间（370是我自定义的每个slide的宽度）
              nextTime = 5500 * ((nextTransPosition - nowTransPosition) / 370)
              // 改变行内transform属性
              document
                .getElementsByClassName('PartSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nowTransForm
              // 不写也没关系
              document
                .getElementsByClassName('PartSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = '0ms'
              this.swiper.stopAutoplay()
            }
            // 鼠标离开轮播图开始轮播
            this.swiper.container[0].onmouseout = function() {
              // console.log('leave' + nextTransForm)
              // 恢复原样
              document
                .getElementsByClassName('PartSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nextTransForm
              document
                .getElementsByClassName('PartSwiper-container')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = nextTime + 'ms'
              this.swiper.startAutoplay()
            }
          })
        }
      })
    },
  
    mouseenterNewsHd(val) {
      var _this = this
      _this.activeNewsHd = val
    },
  }
}
</script>
<style scoped>
  /* CDN 服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: 'iconfont';  /* Project id 3165120 */
  src: url('//at.alicdn.com/t/c/font_3165120_07czs9md4zuf.woff2?t=1666161990257') format('woff2'),
       url('//at.alicdn.com/t/c/font_3165120_07czs9md4zuf.woff?t=1666161990257') format('woff'),
       url('//at.alicdn.com/t/c/font_3165120_07czs9md4zuf.ttf?t=1666161990257') format('truetype');
}
.iconfont {
  font-family: 'iconfont' !important;
  font-size: 52px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.home{
  width: 100%;
  height: auto;
}
.mainHome {
  margin-top: 10px;
  width: 100%;
  height: auto;
}
.mianWrap{
  /* width: 1920px; */
  margin: 0 auto;
  height: auto;
}
.News{
  width: 100%;
  height: 688px;
  overflow: hidden;
  padding-top: 30px;
  background: url(../assets/image/news.png) top center no-repeat;
  background-size: 100% 100%;
}
.ComTit {
    width: 100%;
    height: 140px;
    text-align: center;
}
.ComTit .t1 {
    width: 100%;
    height: 60px;
    border-bottom: 1px #dde4ea solid;
    text-align: center;
    font-size: 40px;
    color: #c1c5c6;
}
.ComTit .t2 {
    width: 170px;
    height: 80px;
    background: url(../assets/image/t_b.jpg) top center no-repeat;
    text-align: center;
    line-height: 80px;
    font-size: 28px;
    margin: -5px auto 0px auto;
}
.homeNewsCon{
  padding-top: 30px;
}
.homeNewsCon .news_list li:first-child {
    margin-left: 0px;
}
.homeNewsCon .news_list li {
    width: 285px;
    height: 340px;
    display: block;
    float: left;
    margin-left: 20px;
    background-color: #FFFFFF;
}
.homeNewList .newsImg{
  width: 285px;
  height: 190px;
  overflow: hidden;
}
.homeNewList .newsImg img{
  width: 285px;
  height: 190px;
  -moz-transition: all 0.8s ease-in;
  -webkit-transition: all 0.8s ease-in;
  -o-transition: all 0.8s ease-in;
  transition: all 0.8s ease-in;
}
.homeNewList:hover img{
  -moz-transform: scale(1.2);
  -webkit-transform: scale(1.2);
  -o-transform: scale(1.2);
  transform: scale(1.2);
}
.homeNewList .nr {
  width: 255px;
  margin: 0 auto;
  color: #888888;
  padding-top: 10px;
  line-height: 24px;
}
.homeNewList .nr p {
  width: 100%;
  color: #000000;
  font-size: 16px;
  margin: 5px 0px;
  font-weight: 500;

}
.homeNewList .nr span {
  color: #cbcbcb;
}
.homeNewList a {
  font-family: "微软雅黑", "Microsoft YaHei",sans-serif;
  font-size: 16px;
}
.business{
  width: 100%;
  height: auto;
  margin-top: 30px;
}
.Product{
  width: 100%;
  overflow: hidden;
}
.Product ul li {
  width: 285px;
  height: 440px;
  display: block;
  float: left;
  margin-left: 20px;
  background-color: #eeeeee;
}
.Product ul li .p1 {
  width: 90px;
  height: 90px;
  border: 5px #037edb solid;
  border-radius: 90px;
  margin: 60px auto 0px auto;
  text-align: center;
  line-height: 90px;
  font-size: 45px;
  color: #037edb;
}
.Product h3 {
  text-align: center;
  padding: 20px 0;
  font-size: 24px;
  font-weight: 400;
}
.Product ul li .p2 {
  width: 240px;
  margin: 20px auto 0px auto;
  border-top: 1px #97b6e2 solid;
  padding-top: 30px;
  padding-bottom: 20px;
}
.Product ul li .p2 a {
  width: 100%;
  height: 22px;
  text-align: center;
  line-height: 22px;
  display: block;
  font-size: 14px;
}
.Product ul li .more {
  width: 90px;
  height: 22px;
  border: 1px #037edb solid;
  border-radius: 8px;
  margin: 0 auto;
  color: #037edb;
  line-height: 22px;
  text-align: center;
  display: block;
}
.Product ul li:hover {
  background-color: #037edb;
  color:#FFFFFF
}
.Product ul li:hover .more{
  border: 1px #FFF solid;
  color: #FFF;
}
.Product ul li:hover .p2 a{
  color: #FFF;
}
.Product ul li:hover .p1 {
  border-color: #FFFFFF;
  color: #FFFFFF;
}
.Product ul li:hover h3 {
  animation: comUla 0.5s linear 1;
  color: #FFFFFF;
  transition: all .5s ease-in;
}
@keyframes comUla {
  from {
    transform: translateY(0px);
  }
  to {
    transform: translateY(8px);
  }
}

.Product ul li:hover .p1 .iconfont{
  transition: All 0.4s linear ;
  -webkit-transition: All 0.4s linear ;
  -moz-transition: All 0.4s linear ;
  -o-transition: All 0.4s linear ;
  display: inline-block;
}

.Product ul li:hover .p1 .iconfont{
  
  transform: rotate(360deg) scale(1.2);
  -webkit-transform: rotate(360deg) scale(1.2);
  -moz-transform: rotate(360deg) scale(1.2);
  -o-transform: rotate(360deg) scale(1.2);
  -ms-transform: rotate(360deg) scale(1.2);
}

.About{
  height: 600px;
  margin-top: 50px;
}
.Partner{
  width: 100%;
  height: 690px;
  background: url(../assets/image/partner_bj.jpg) center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  margin-top: 40px;
}
.AboutMain{
height: 390px;
}
#AboutProj .AboutSwiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  position: inherit;
  list-style: none;
  padding: 0;
  z-index: 1;
}
#AboutProj .AboutSwiper-container .AboutSwiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  box-sizing: content-box;
  -webkit-transition-timing-function: linear;    /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;

}
#AboutProj .AboutSwiper-container .AboutSwiper-slide {
  text-align: center;
  font-size: 18px;
  width: 380px;
  margin-right: 30px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}
#AboutProj .AboutItem{
  width: 100%;
  height: 382px;
  /* background-color: #f0f4f5; */
  display: block;
  overflow: hidden;
  border: 10px #dadada solid;
  box-sizing: border-box;
}
#AboutProj .AboutItem .img {
  width: 100%;
  height: 242px;
  overflow: hidden;
}
#AboutProj .AboutItem .img .swiper_img{
  transition: all 0.5s ease-in;
  -webkit-transition: 0.5s all ease-in; /* 适用Safari 和 Chrome兼容 */
  -moz-transition: 0.5s all ease-in; /* 适用Firefox兼容 */
  -ms-transition: 0.5s all ease-in; /* 适用IE9兼容 */
  -o-transition: 0.5s all ease-in; /* Opera */
  height: 242px;
}
#AboutProj .AboutItem .Tit {
  width: 100%;
  /* height: 35px; */
  text-align: center;
  line-height: 35px;
  font-family: "微软雅黑", "Microsoft YaHei",sans-serif;
  font-size: 16px;
  color: #000000;
  padding: 15px 5px 0 5px;
  box-sizing: border-box;
}
#AboutProj .AboutSwiper-container .AboutSwiper-slide:hover .Tit{
  color: #0162b3;
}
#AboutProj .AboutSwiper-container .AboutSwiper-slide:hover .AboutItem .img .swiper_img{
  transform: scale(1.2);
  -webkit-transform: scale(1.2); /*在Safari 和 Chrome兼容下还原*/
  -moz-transform: scale(1.2); /*在Firefox兼容下还原*/
  -ms-transfrom: scale(1.2); /*在IE9兼容下还原*/
  -o-transform: scale(1.2); /*在opera兼容下还原*/
  transform: scale(1.2); /*适用于所有浏览兼容下还原*/

  /* transform: rotate(360deg) scale(1.2);
  -webkit-transform: rotate(360deg) scale(1.2);
  -moz-transform: rotate(360deg) scale(1.2);
  -o-transform: rotate(360deg) scale(1.2);
  -ms-transform: rotate(360deg) scale(1.2); */
}
.Aboutmore {
  width: 100px;
  height: 36px;
  background-color: #e8e9ee;
  display: block;
  color: #6e706d;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  margin: 0 auto;
  border-radius: 3px;
  opacity: 0.7;
  margin-top: 20px;
}
#AboutProj .swiper-button-prev-About{
  top: auto;
  left: auto;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../assets/image/z.png);
  list-style: none;
  margin-top: -215px;
  margin-left: -40px;
}


#AboutProj .swiper-button-next-About{
  top: auto;
  margin-top: -215px;
  background-image: none;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../assets/image/y.png);
  right: auto;
  margin-left: 1210px;

}
.PartnerMain{
  height: 390px;
}
#PartnerProj .PartSwiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  position: inherit;
  list-style: none;
  padding: 0;
  z-index: 1;
}
#PartnerProj .PartSwiper-container .PartSwiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  box-sizing: content-box;
  -webkit-transition-timing-function: linear;    /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
#PartnerProj .PartSwiper-container .PartSwiper-slide {
  text-align: center;
  font-size: 18px;
  width: 380px;
  margin-right: 30px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
}
#PartnerProj .PartItem{
  width: 100%;
  height: 382px;
  /* background-color: #f0f4f5; */
  display: block;
  overflow: hidden;
  border: 10px #dadada solid;
  box-sizing: border-box;
}
#PartnerProj .PartItem .img {
  width: 100%;
  height: 242px;
  overflow: hidden;
}
#PartnerProj .PartItem .img .Part_img{
  transition: all 0.5s ease-in;
  -webkit-transition: 0.5s all ease-in; /* 适用Safari 和 Chrome兼容 */
  -moz-transition: 0.5s all ease-in; /* 适用Firefox兼容 */
  -ms-transition: 0.5s all ease-in; /* 适用IE9兼容 */
  -o-transition: 0.5s all ease-in; /* Opera */
  height: 242px;
}
#PartnerProj .PartItem .PatBack{
  width: 100%;
  height: 140px;
  background-color: rgba(235, 235, 235, 0.4);
}
#PartnerProj .PartItem .PartTit {
  width: 100%;
  /* height: 35px; */
  text-align: center;
  line-height: 35px;
  font-family: "微软雅黑", "Microsoft YaHei",sans-serif;
  font-size: 16px;
  color: #000000;
  padding: 15px 5px 0 5px;
  box-sizing: border-box;
  /* z-index: 999; */
}
#PartnerProj .PartSwiper-container .PartSwiper-slide:hover .PartTit{
  color: #0162b3;
}
#PartnerProj .PartSwiper-container .PartSwiper-slide:hover .PartItem .img .Part_img{
  transform: scale(1.2);
  -webkit-transform: scale(1.2); /*在Safari 和 Chrome兼容下还原*/
  -moz-transform: scale(1.2); /*在Firefox兼容下还原*/
  -ms-transfrom: scale(1.2); /*在IE9兼容下还原*/
  -o-transform: scale(1.2); /*在opera兼容下还原*/
  transform: scale(1.2); /*适用于所有浏览兼容下还原*/
}
#PartnerProj .swiper-button-prev-Part{
  top: auto;
  left: auto;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../assets/image/z.png);
  list-style: none;
  margin-top: -215px;
  margin-left: -40px;
}


#PartnerProj .swiper-button-next-Part{
  top: auto;
  margin-top: -215px;
  background-image: none;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  background-image: url(../assets/image/y.png);
  right: auto;
  margin-left: 1210px;

}
</style>
